import { useTranslation } from 'react-i18next';
import { useMatchRoute } from '@tanstack/react-router';
import { Outlet } from '@tanstack/react-router';
import { Footer, Header } from '@anytag/shared-molecules';
import { useAuthData } from '@anytag/auth';
import { Anchor } from '@anytag/shared-atoms';
import { WithChannelTalk } from '../../components/WithChannelTalk';
import { TikTokLayoutMenu } from './TikTokLayoutMenu';

export const TikTokSignupLayout = () => {
  const { auth } = useAuthData();
  const { t } = useTranslation();
  const matchRoute = useMatchRoute();
  const isEnterPasswordRoute = matchRoute({
    to: '/tiktok-onboarding/password-enter'
  });

  return (
    <div className="flex min-h-full bg-black-10">
      <TikTokLayoutMenu />
      <div className="ml-60 box-border flex flex-1 flex-col scroll-smooth px-2 py-4 pb-7 pl-6">
        <Header>
          {!auth.userId ? (
            <div className="ml-auto flex text-base leading-none font-normal">
              {t('Already have an account?')}
              <Anchor
                className="ml-2 hover:no-underline hover:opacity-80"
                variant="blue"
                to="/tiktok-onboarding/password-enter"
              >
                {t('Sign in')}
              </Anchor>
            </div>
          ) : isEnterPasswordRoute ? (
            <div className="ml-auto flex text-base leading-none font-normal">
              {t("Don't have an account?")}
              <Anchor className="ml-2 hover:no-underline hover:opacity-80" variant="blue" to="/tiktok-onboarding">
                {t('Sign up')}
              </Anchor>
            </div>
          ) : null}
        </Header>
        <WithChannelTalk>
          <Outlet />
        </WithChannelTalk>
        <Footer hasCombinedTerms />
      </div>
    </div>
  );
};
